export { default } from "./TextSkeleton";
